import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'champtable.adminImpersonate';

/**
 * Session d'impersonation producteur (dev/staging uniquement côté API).
 *
 * L'en-tête HTTP est posé par l'intercepteur ; ce service garde l'identifiant
 * producteur entre les navigations.
 */
@Injectable({ providedIn: 'root' })
export class AdminImpersonationService {
  private readonly profileId = signal<string | undefined>(readStored());

  readonly activeProfileId = this.profileId.asReadonly();

  start(profileId: string): void {
    sessionStorage.setItem(STORAGE_KEY, profileId);
    this.profileId.set(profileId);
  }

  stop(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    this.profileId.set(undefined);
  }

  isActive(profileId?: string): boolean {
    const current = this.profileId();
    if (current === undefined) {
      return false;
    }
    return profileId === undefined ? true : current === profileId;
  }
}

function readStored(): string | undefined {
  const value = sessionStorage.getItem(STORAGE_KEY);
  return value && value.length > 0 ? value : undefined;
}
